export default __webpack_public_path__ + "13ff309.png";